module.exports = __webpack_public_path__ + "static/media/target.65df8ce8.svg";